import { render, staticRenderFns } from "./qscTournament.vue?vue&type=template&id=c0a9eea0&scoped=true"
import script from "./qscTournament.vue?vue&type=script&lang=js"
export * from "./qscTournament.vue?vue&type=script&lang=js"
import style0 from "./qscTournament.vue?vue&type=style&index=0&id=c0a9eea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a9eea0",
  null
  
)

export default component.exports